import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-gray-800">
      {/* Contact Info Section */}
      <div className="bg-white py-12 relative z-20" style={{ backgroundColor: '#ffffff' }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Çalışma Saatleri */}
            <div>
              <h3 className="text-[#997938] font-bold text-lg mb-4">Çalışma Saatleri</h3>
              <div className="space-y-2 text-gray-900">
                <div className="flex justify-between">
                  <span className="font-semibold">Pzt-Cum</span>
                  <span>09:00 - 18:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">Cmt</span>
                  <span>Kapalı</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">Paz.</span>
                  <span>Kapalı</span>
                </div>
              </div>
            </div>

            {/* Bilgi */}
            <div>
              <h3 className="text-[#997938] font-bold text-lg mb-4">Bilgi</h3>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <Phone className="w-5 h-5 text-[#997938] flex-shrink-0" />
                  <a href="tel:05428220286" className="text-gray-900 hover:text-[#997938] transition-colors">
                    0 (542) 822 02 86
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 text-[#997938] flex-shrink-0" />
                  <a href="mailto:av.zeynepgur@outlook.com" className="text-gray-900 hover:text-[#997938] transition-colors">
                    av.zeynepgur@outlook.com
                  </a>
                </div>
              </div>
            </div>

            {/* Konum */}
            <div>
              <h3 className="text-[#997938] font-bold text-lg mb-4">Konum</h3>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#997938] flex-shrink-0 mt-0.5" />
                <p className="text-gray-900">
                  Halkapınar, 1201/1. Sk. No:9 D:21, 35170<br />
                  Konak/İzmir, Türkiye<br />
                  (Mert Ambalaj Üzeri)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Google Maps Section */}
      <div className="w-full h-96 bg-gray-900">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3124.8!2d27.1379!3d38.4396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bbd862a6477e43%3A0x5a8b8e8b8e8b8e8b!2sHalkap%C4%B1nar%2C%201201%2F1.%20Sk.%20No%3A9%2C%2035170%20Konak%2F%C4%B0zmir!5e0!3m2!1str!2str!4v1620000000000!5m2!1str!2str"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Avukat Zeynep Gür Ofis Konumu - Halkapınar, İzmir"
        />
      </div>

      {/* Copyright Section */}
      <div className="bg-black py-6">
        <div className="w-full px-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center space-x-3 mb-4 md:mb-0">
              <img 
                src="https://customer-assets.emergentagent.com/job_avukat-portal-6/artifacts/occ791mb_image.png" 
                alt="Logo" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-500 text-sm text-center md:text-right">
              © {new Date().getFullYear()} Avukat Zeynep Gür. Tüm hakları saklıdır.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;